import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Note, Step } from '@mytypes/protocol';
import { RootState } from '@state-mgmt/store';

export type NotesState = {
  notes: Note[] | null;
  currentNote: Note | undefined;
  steps: { [protocolId: string]: Step[] | null | undefined };
};

const initialState: NotesState = {
  notes: null,
  currentNote: undefined,
  steps: {}
};

export const protocolSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setNotes(state: NotesState, action: PayloadAction<Note[]>) {
      state.notes = action.payload;
    },
    setCurrentNote(state: NotesState, action: PayloadAction<Note | undefined>) {
      state.currentNote = action.payload ;
    },
    setStepsForNotes(state: NotesState, action: PayloadAction<{ protocolId: string; steps: Step[] | null | undefined }>) {
      state.steps = {
        ...state.steps,
        [action.payload.protocolId]: action.payload.steps
      };
    }
  }
});

// Actions
export const { setNotes, setCurrentNote, setStepsForNotes } = protocolSlice.actions;

// Selectors
export const selectNotes = (state: RootState) => state.notes.notes;
export const selectCurrentNote = (state: RootState) => state.notes.currentNote;

export default protocolSlice.reducer;
